export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE"
export const TOGGLE_WELCOME = "TOGGLE_WELCOME"
export const LOG_IN = "LOG_IN"
export const LOG_OUT = "LOG_OUT"
export const TOGGLE_STARTUP_ONEPAGER = "TOGGLE_STARTUP_ONEPAGER"
export const SET_APPLICATION_STATE = "SET_APPLICATION_STATE"
export const SET_SIDEBAR_SETTINGS = "SET_SIDEBAR_SETTINGS"
export const SET_NB_STARTUPS_LIST = "SET_NB_STARTUPS_LIST"
